// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-player[data-v-329f66c7]{margin:12px 0;width:100%}`, "",{"version":3,"sources":["webpack://./src/components/MessagesList/MessagesGroup/Message/MessagePart/AudioPlayer.vue"],"names":[],"mappings":"AAEA,+BACC,aAAA,CACA,UAAA","sourcesContent":["\n\n.audio-player {\n\tmargin: 12px 0;\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
